import { SvgIcon } from '@material-ui/core'
import React from 'react'

const GeolocateIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        d="M12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12Z"
      />
      <path
        fillRule="evenodd"
        d="M12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z"
      />
      <path
        fillRule="evenodd"
        d="M22 12.5H20V11.5H22C22.2761 11.5 22.5 11.7239 22.5 12C22.5 12.2761 22.2761 12.5 22 12.5Z"
      />
      <path
        fillRule="evenodd"
        d="M12.5 2L12.5 4L11.5 4L11.5 2C11.5 1.72386 11.7239 1.5 12 1.5C12.2761 1.5 12.5 1.72386 12.5 2Z"
      />
      <path
        fillRule="evenodd"
        d="M2 11.5L4 11.5L4 12.5L2 12.5C1.72386 12.5 1.5 12.2761 1.5 12C1.5 11.7239 1.72386 11.5 2 11.5Z"
      />
      <path
        fillRule="evenodd"
        d="M11.5 22L11.5 20L12.5 20L12.5 22C12.5 22.2761 12.2761 22.5 12 22.5C11.7239 22.5 11.5 22.2761 11.5 22Z"
      />
    </SvgIcon>
  )
}

export default GeolocateIcon
